import env from "../../env";
import {expressions, regexValidators} from "../../survey/validators";

const required = env.ENDPOINT !== "local";

const applicant_information = {
  title: {
    en: "Applicant Information",
    rw: "Amakuru y’usaba",
  },
  name: "applicant",
  elements: [
    {
      title: { en: "Applicant first Name", rw: "Izina ry’idini" },
      name: "first_name",
      type: "text",
      description: {
        en: "If not existent, leave empty",
        rw: "Niba nta rindi zina ufite, hasige ubusa",
      },
    },
    {
      title: { en: "Applicant last name *", rw: "Izina ry’umuryango*" },
      name: "last_name",
      type: "text",
      isRequired: required,
    },
    {
      title: {
        en: "Can you share a picture for yourself? *",
        rw: "Waduha ifoto yawe? *",
      },
      name: "profile_avatar",
      type: "file_uploader",
      accept: "image/*,application/pdf",
      isRequired: required,
    },
    {
      title: {
        en: "Date of Birth *",
        rw: "Itariki yamavuko *",
      },
      name: "date_of_birth",
      type: "text",
      inputType: "date",
      validators: [
        {
          type: "expression",
          text: {
            en: "You must be older than 18 and younger than 70 to apply",
            rw: "Ugomba nibura kuba ufite imyaka 18 kandi utarengeje imyaka 70 kugirango usabe inguzanyo",
          },
          expression:
            "(age({date_of_birth}) >= 18) && (age({date_of_birth}) < 70)",
        },
      ],
      isRequired: required,
    },
    {
      title: {
        en: "What is your gender? *",
        rw: "Igitsina ni ikihe? *",
      },
      name: "gender",
      type: "radiogroup",
      isRequired: required,
      choices: [
        { value: "male", text: { en: "Male", rw: "Gabo" } },
        { value: "female", text: { en: "Female", rw: "Gore" } },
      ],
    },
    {
      type: "html",
      html: {
        en: "The following questions are for informational purposes only and will not be considered in the assessment of your loan application.",
        rw: "Ibibazo bikurikira bigamije gutanga amakuru gusa kandi ntabwo bizagenderwaho mu kugenzura ubusabe bw’inguzanyo yawe",
      },
    },
    {
      name: "custom_bool_4",
      type: "radiogroup",
      isRequired: required,
      title: {
        en: "Do you hold a refugee / IDP status? *",
        rw: "Mwaba mufite ibyangombwa by’ubuhunzi? *",
      },
      choices: [
        {
          value: true,
          text: { en: "Yes", rw: "Yego" },
        },
        {
          value: false,
          text: { en: "No", rw: "Oya" },
        },
      ],
    },
    {
      name: "custom_bool_5",
      type: "radiogroup",
      isRequired: required,
      title: {
        en: "Do you have any disability? *",
        rw: "Mwaba mubana n’ubumuga? *",
      },
      choices: [
        {
          value: true,
          text: { en: "Yes", rw: "Yego" },
        },
        {
          value: false,
          text: { en: "No", rw: "Oya" },
        },
      ],
    },
    {
      title: {
        en: "How many people live in your household ?*",
        rw: "Ni abantu bangahe muba mu nzu imwe ?*",
      },
      name: "custom_integer_1",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 1,
          text: {
            en: "Please make sure the number is 1 or more",
            rw: "Nyamuneka menya neza ko umubare ari 1 cyangwa urenzeho",
          },
        },
      ],
    },
  ]
}

const identification_information = {
  name: "identification",
  title: {
    en: "Identification Information *",
    rw: "Amakuru ajyanye n'umwirondoro *",
  },
  elements: [
    {
      name: "nationality",
      type: "dropdown",
      isRequired: required,
      storeOthersAsComment: false,
      hasOther: true,
      title: {
        en: "Nationality *",
        rw: "Ubwenegihugu *",
      },
      choices: [
        {
          value: "rwandan",
          text: {
            en: "Rwandan",
            rw: "Umunyarwanda",
          },
        },
      ],
    },
    {
      name: "id_number",
      type: "text",
      isRequired: required,
      validators: [
        {
          type: "regexvalidator",
          text: {
            en: "Number should be from 16 digits length",
            rw: "Imibare igomba kuba ari 16",
          },
          regex: "^[0-9]{16}$",
        },
      ],
      title: {
        en: "ID No. *",
        rw: "Nimero y'indangamuntu  *",
      },
    },
    {
      visibleIf: "{id_number} notempty",
      name: "id_number_validator",
      type: "text",
      isRequired: required,
      title: {
        en: "Please, type your ID number again *",
        rw: "Ongera wandike nomero y'indangamuntu yawe *",
      },
      validators: [
        {
          type: "expression",
          expression: "{id_number} == {id_number_validator}",
          text: {
            en: "Please make sure both numbers are the same",
            rw: "Nyamuneka reba neza ko imibare yombi ari imwe"
          }
        }
      ],
    },
    {
      title: {
        en: "Front Image (Attachment) *",
        rw: "Ifoto y'imbere y'indangamuntu *",
      },
      description: {
        en: "If you don't have an ID card upload the replacement document.",
        rw: "Niba udafite indangamuntu shyiraho icyangombwa kiyisimmbura",
      },
      name: "id_file",
      type: "file_uploader",
      accept: "image/*,application/pdf",
      isRequired: required,
    },
    {
      name: "id_avatar",
      type: "panel",
      innerIndent: 1,
      title: {
        en: "Please verify your identity",
        rw: "Emeza umwirondoro wawe",
      },
      elements: [
        {
          name: "id_avatar_desc",
          type: "html",
          description: {
            en: "To complete the verification, please upload a photo of yourself holding your ID card clearly visible next to your face.",
            rw: "Kugirango wemeze umwirondoro, shyiraho ifoto yawe ufashe indangamuntu hafi y'isura yawe.",
          },
          html: {
            en: "To complete the verification, please upload a photo of yourself holding your ID card clearly visible next to your face.",
            rw: "Kugirango wemeze umwirondoro, shyiraho ifoto yawe ufashe indangamuntu hafi y'isura yawe.",
          },
        },
        {
          name: "id_avatar_desc_picture",
          type: "html",
          html: `<img alt="example" src='${require("../../assets/images/example_card.png")}' width='200'/>`,
        },
        {
          name: "id_file_with_avatar",
          type: "file_uploader",
          isRequired: required,
          accept: "image/*,application/pdf",
          title: {
            en: "Identification Picture *",
            rw: "Ifoto igaragaza umuntu *",
          },
        },
      ],
    },
    {
      title: {
        en: "What is your marital status? *",
        rw: "Irangamimerere ni irihe? *",
      },
      name: "marital",
      type: "radiogroup",
      isRequired: required,
      choices: [
        { value: "married", text: { en: "Married", rw: "Ndubatse" } },
        { value: "single", text: { en: "Single", rw: "Ingaragu" } },
        { value: "divorced", text: { en: "Divorced", rw: "Yaratandukanye" } },
        { value: "widowed", text: { en: "Widowed", rw: "Umupfakare" },  visibleIf: "{gender} == 'male'" },
        { value: "widowed", text: { en: "Widowed", rw: "Umupfakazi" },  visibleIf: "{gender} == 'female'" },
      ],
    },
    {
      title: { en: "Full name of partner *", rw: "Amazina y'uwo mwashakanye *" },
      name: "custom_text_2",
      type: "text",
      visibleIf: "{marital} == 'married'",
      isRequired: required,
    },
    {
      name: "custom_text_3",
      type: "phone",
      isRequired: required,
      visibleIf: "{marital} == 'married'",
      validators: [
        expressions.phone_en("custom_text_3"),
        expressions.phone_length("custom_text_3"),
      ],
      title: {
        en: "Telephone number of your partner *",
        rw: "Numero ya telephone y'uwo mwashakanye *",
      },
    },
    {
      name: "custom_text_4",
      type: "text",
      isRequired: required,
      visibleIf: "{marital} == 'married'",
      validators: [
        {
          type: "regexvalidator",
          text: {
            en: "Number should be from 16 digits length",
            rw: "Imibare igomba kuba ari 16",
          },
          regex: "^[0-9]{16}$",
        },
      ],
      title: {
        en: "ID number of your partner *",
        rw: "Numero y'indangamuntu *",
      },
    },
    {
      title: {
        en: "Upload the ID of your partner *",
        rw: "Shyiraho indangamuntu y'uwo mwashakanye *",
      },
      description: {
        en: "If you don't have an ID card upload the replacement document.",
        rw: "Niba udafite indangamuntu shyiraho icyangombwa kiyisimmbura",
      },
      name: "file_3",
      visibleIf: "{marital} == 'married'",
      type: "file_uploader",
      accept: "image/*,application/pdf",
      isRequired: required,
    },
    {
      title: {
        en: "Have you applied before for a loan with MoneyPhone?",
        rw: "Wigeze usaba inguzanyo ukoresheje MoneyPhone ?",
      },
      name: "custom_text_1",
      type: "dropdown",
      choices: [
        {
          value: "yes",
          text: { en: "Yes", rw: "Yego" },
        },
        {
          value: "no",
          text: { en: "No", rw: "Oya" },
        },
      ],
    },
    {
      title: {
        en: "How much has your income changed after receiving a loan from MoneyPhone? *",
        rw: "Ni iyihe mpinduka yabaye ku mafaranga winjiza nyuma yo guhabwa inguzanyo muri MoneyPhone? *",
      },
      name: 'custom_text_15',
      type: "radiogroup",
      visibleIf: "{custom_text_1} == 'yes'",
      isRequired: required,
      choices: [
        {
          value: "No noticeable change",
          text: {
            en: "No noticeable change",
            rw: "Nta mpinduka igaragara",
          },
        },
        {
          value: "It increased by less than 100.000 RWF",
          text: {
            en: "It increased by less than 100.000 RWF",
            rw: "Hiyongereyeho ari munsi ya 100.000 Rwf",
          },
        },
        {
          value: "It increased between 100.000 RWF - 500.000 RWF",
          text: {
            en: "It increased between 100.000 RWF - 500.000 RWF",
            rw: "Hiyongereyeho ari hagati ya 100.000 Rwf na 500.000 Rwf",
          },
        },
        {
          value: "It increased between 500.000 RWF - 1.000.000 RWF",
          text: {
            en: "It increased between 500.000 RWF - 1.000.000 RWF",
            rw: "Hiyongereyeho ari hagati ya 500.000 Rwf na 1.000.000 Rwf",
          },
        },
        {
          value: "It increased by more than 1 million RWF ",
          text: {
            en: "It increased by more than 1 million RWF ",
            rw: "Hiyongereyeho arenga Rwf Miliyoni 1",
          },
        },
      ],
    },
  ],
}

const residence_and_home_information = (clientUrlForCatalog) => [
  {
    title: {
      en: "Residence & Home Information",
      rw: "Amakuru yaho utuye",
    },
    name: "home",
    elements: [
      {
        title: {
          en: "Where do you live?",
          rw: "Utuye he?",
        },
        name: "panel_home",
        type: "panel",
        innerIndent: 1,
        elements: [
          {
            name: "province",
            type: "dropdown",
            isRequired: required,
            title: {
              en: "Province *",
              rw: "Intara *",
            },
            renderAs: "select2",
            choicesByUrl: {
              url: `${clientUrlForCatalog}/api/tenant-data/provinces/`,
              path: "results",
              titleName: "value",
              valueName: "value",
              attachOriginalItems: true,
            },
          },
          { type: "text", name: "Idprovince", visible: false },
          {
            name: "district",
            type: "dropdown",
            isRequired: required,
            title: {
              en: "District *",
              rw: "Akarere *",
            },
            renderAs: "select2",
            choicesByUrl: {
              url: `${clientUrlForCatalog}/api/tenant-data/districts/?province_id={Idprovince}`,
              path: "results",
              titleName: "value",
              valueName: "value",
              attachOriginalItems: true,
            },
          },
          { type: "text", name: "Iddistrict", visible: false },
          {
            name: "home_country", // Mapped to home country for now. Field on the backend will be renamed later.
            type: "dropdown",
            isRequired: required,
            title: {
              en: "Sector *",
              rw: "Umurenge *",
            },
            renderAs: "select2",
            choicesByUrl: {
              url: `${clientUrlForCatalog}/api/tenant-data/sectors/?district_id={Iddistrict}`,
              path: "results",
              titleName: "value",
              valueName: "value",
              attachOriginalItems: true,
            },
          },
          { type: "text", name: "Idsector", visible: false },
          {
            name: "cell",
            type: "dropdown",
            isRequired: required,
            title: {
              en: "Cell *",
              rw: "Akagali *",
            },
            renderAs: "select2",
            choicesByUrl: {
              url: `${clientUrlForCatalog}/api/tenant-data/cells/?sector_id={Idsector}`,
              path: "results",
              titleName: "value",
              valueName: "value",
              attachOriginalItems: true,
            },
          },
          { type: "text", name: "Idcell", visible: false },
          {
            name: "village",
            type: "dropdown",
            isRequired: required,
            title: {
              en: "Village *",
              rw: "Umudugudu *",
            },
            renderAs: "select2",
            choicesByUrl: {
              url: `${clientUrlForCatalog}/api/tenant-data/villages/?cell_id={Idcell}`,
              path: "results",
              titleName: "value",
              valueName: "value",
              attachOriginalItems: true,
            },
          },
        ],
      },
    ],
  },
];

const production_information_default = {
  name: "production",
  title: {
    en: "Production Information",
    rw: "Amakuru y'umusaruro",
  },
  description: {
    en: "The production information provided will be verified and confirmed by the cooperative.",
    rw: "Amakuru y'umusaruro azasuzumwa kandi yemezwe na koperative",
  },
  elements: [
    {
      title: {
        en: "Provide us with production information of 2 previous agriculture seasons",
        rw: "Duhe amakuru y'umusaruro ku bihembwe 2 bishize",
      },
      name: "panel_home",
      type: "panel",
      innerIndent: 1,
      elements: [
        {
          title: {
            en: "Season 1",
            rw: "Igihembwe cya 1",
          },
          name: "agricultural_season_1",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "land_size_season_1",
              type: "text",
              inputType: "number",
              title: {
                en: "Cultivated land in square meters",
                rw: "Ubutaka buhingwaho muri metero kare",
              },
              validators: [expressions.land_size_square_meters(), regexValidators.max_three_decimal_places()],
            },
            {
              name: "supply_volume_kg_season_1",
              type: "text",
              inputType: "number",
              isRequired: required,
              title: {
                en: "Production of the selected crop in KGs *",
                rw: "Ingano y'umusaruro ku gihingwa wahisemo muri kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_season_1",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko bw'igihingwa wahisemo",
              },
            },
            {
              name: "price_season_1",
              isRequired: required,
              type: "text",
              inputType: "number",
              title: {
                en: "Price of the selected crop/kg in RWF *",
                rw: "Igiciro ku kilo ku gihingwa wahisemo(RWF) *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_season_1",
              type: "text",
              inputType: "number",
              isRequired: required,
              title: {
                en: "Sales of selected crop in RWF *",
                rw: "Amafaranga winjije yose ku gihingwa wahisemo (RWF) *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
          ],
        },
        {
          title: {
            en: "Season 2",
            rw: "Igihembwe cya 2",
          },
          name: "agricultural_season_2",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "land_size_season_2",
              isRequired: required,
              type: "text",
              inputType: "number",
              title: {
                en: "Cultivated land in square meters *",
                rw: "Ubutaka buhingwaho muri metero kare *",
              },
              validators: [expressions.land_size_square_meters(), regexValidators.max_three_decimal_places()],
            },
            {
              name: "supply_volume_kg_season_2",
              isRequired: required,
              type: "text",
              title: {
                en: "Production of the selected crop in KG *",
                rw: "Ingano y'umusaruro ku gihingwa wahisemo muri kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_season_2",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko bw'igihingwa wahisemo",
              },
            },
            {
              name: "price_season_2",
              type: "text",
              isRequired: required,
              title: {
                en: "Price of the selected crop/kg in RWF *",
                rw: "Igiciro ku kilo ku gihingwa wahisemo(RWF) *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_season_2",
              type: "text",
              isRequired: required,
              title: {
                en: "Sales of the selected crop in Rwf *",
                rw: "Amafaranga winjije yose ku gihingwa wahisemo (RWF) *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
          ],
        },
        {
          title: {
            en: "Information on current season of the selected crop",
            rw: "Amakuru ku gihembwe ugiye guhinga",
          },
          name: "current_agricultural_season",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "land_size_current_season",
              type: "text",
              inputType: "number",
              isRequired: required,
              title: {
                en: "Expected cultivated land in square meters.",
                rw: "Ubutaka buteganywa guhingwaho muri metero kare",
              },
              validators: [expressions.land_size_square_meters(), regexValidators.max_three_decimal_places()],
            },
            {
              name: "supply_volume_kg_current_season",
              type: "text",
              isRequired: required,
              title: {
                en: "Expected production of selected crop in KG *",
                rw: "Ingano y'umusaruro uteganyijwe  muri kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_current_season",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko uteganya guhinga",
              },
            },
            {
              name: "price_current_season",
              type: "text",
              isRequired: required,
              title: {
                en: "Expected price of selected crop/kg in RWF *",
                rw: "Igiciro uteganya kugurishirizaho (RWF) *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_current_season",
              type: "text",
              isRequired: required,
              title: {
                en: "Expected sales of selected crop in Rwf *",
                rw: "Amafaranga yose uteganya kwinjiza (RWF) *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "plot_ownership_season_1",
              type: "radiogroup",
              isRequired: required,
              title: {
                en: "Do you own a land ?*",
                rw: "Ufite ubutaka uhingaho ?*",
              },
              choices: [
                {
                  value: true,
                  text: {
                    en: "Yes",
                    rw: "Yego",
                  },
                },
                {
                  value: false,
                  text: {
                    en: "No",
                    rw: "Oya",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
}

const production_information_chili = {
  name: "production",
  title: {
    en: "Production Information",
    rw: "Amakuru y'umusaruro",
  },
  description: {
    en: "The production information provided will be verified and confirmed by the cooperative.",
    rw: "Amakuru y'umusaruro azasuzumwa kandi yemezwe na koperative",
  },
  elements: [
    {
      title: {
        en: "Provide us with production information of 2 previous agriculture seasons",
        rw: "Duhe amakuru y'umusaruro ku bihembwe 2 bishize",
      },
      name: "panel_home",
      type: "panel",
      innerIndent: 1,
      elements: [
        {
          title: {
            en: "Season 1",
            rw: "Igihembwe cya 1",
          },
          name: "agricultural_season_1",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "land_size_season_1",
              type: "text",
              inputType: "number",
              title: {
                en: "Cultivated land in square meters *",
                rw: "Ubutaka buhingwaho muri metero kare *",
              },
              validators: [expressions.land_size_square_meters(), regexValidators.max_three_decimal_places()],
            },
            {
              name: "supply_volume_kg_season_1",
              type: "text",
              inputType: "number",
              isRequired: required,
              title: {
                en: "Production supplied to the exporter in Kgs *",
                rw: "Ingano yumusaruro wagemuye kuri rwiyemezamirimo muri Kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_season_1",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko bw'igihingwa wahisemo",
              },
            },
            {
              name: "price_season_1",
              isRequired: required,
              type: "text",
              inputType: "number",
              title: {
                en: "Price paid by the exporter per 1 Kg *",
                rw: "Igiciro wishyuwe na rwiyemezamirimo kuri Kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_season_1",
              type: "text",
              inputType: "number",
              isRequired: required,
              title: {
                en: "Total amount received form exporter *",
                rw: "Amafaranga yose wishyuwe na Rwiyemezamirimo *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
          ],
        },
        {
          title: {
            en: "Season 2",
            rw: "Igihembwe cya 2",
          },
          name: "agricultural_season_2",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "land_size_season_2",
              isRequired: required,
              type: "text",
              inputType: "number",
              title: {
                en: "Cultivated land in square meters *",
                rw: "Ubutaka buhingwaho muri metero kare *",
              },
              validators: [expressions.land_size_square_meters(), regexValidators.max_three_decimal_places()],
            },
            {
              name: "supply_volume_kg_season_2",
              isRequired: required,
              type: "text",
              title: {
                en: "Production supplied to the exporter in Kgs *",
                rw: "Ingano yumusaruro wagemuye kuri rwiyemezamirimo muri Kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_season_2",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko bw'igihingwa wahisemo",
              },
            },
            {
              name: "price_season_2",
              type: "text",
              isRequired: required,
              title: {
                en: "Price paid by the exporter per 1 Kg *",
                rw: "Igiciro wishyuwe na rwiyemezamirimo kuri Kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_season_2",
              type: "text",
              isRequired: required,
              title: {
                en: "Total amount received form exporter *",
                rw: "Amafaranga yose wishyuwe na Rwiyemezamirimo *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
          ],
        },
        {
          title: {
            en: "Information on current season of the selected crop",
            rw: "Amakuru ku gihembwe ugiye guhinga",
          },
          name: "current_agricultural_season",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "land_size_current_season",
              type: "text",
              inputType: "number",
              isRequired: required,
              title: {
                en: "Expected cultivated land in square meters.",
                rw: "Ubutaka buteganywa guhingwaho muri metero kare",
              },
              validators: [expressions.land_size_square_meters(), regexValidators.max_three_decimal_places()],
            },
            {
              name: "supply_volume_kg_current_season",
              type: "text",
              isRequired: required,
              title: {
                en: "Expected production supplied to the exporter in Kgs *",
                rw: "Ingano yumusaruro uteganya kuzagemura kuri rwiyemezamirimo *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_current_season",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko uteganya guhinga",
              },
            },
            {
              name: "price_current_season",
              type: "text",
              isRequired: required,
              title: {
                en: "Expected price paid by the exporter per 1 Kg *",
                rw: "Igiciro uteganya kuzishyurwa na rwiyemezamirimo kuri kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_current_season",
              type: "text",
              isRequired: required,
              title: {
                en: "Expected total amount received form exporter *",
                rw: "Amafaranga yose uteganya kuzishyurwa na rwiyemezamirimo *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "plot_ownership_season_1",
              type: "radiogroup",
              isRequired: required,
              title: {
                en: "Do you own a land ?*",
                rw: "Ufite ubutaka uhingaho ?*",
              },
              choices: [
                {
                  value: true,
                  text: {
                    en: "Yes",
                    rw: "Yego",
                  },
                },
                {
                  value: false,
                  text: {
                    en: "No",
                    rw: "Oya",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
}

const production_information_tea = {
  name: "production",
  title: {
    en: "Production Information",
    rw: "Amakuru y'umusaruro",
  },
  description: {
    en: "The production information provided will be verified and confirmed by the cooperative.",
    rw: "Amakuru y'umusaruro azasuzumwa kandi yemezwe na koperative",
  },
  elements: [
    {
      title: {
        en: "Provide with us production information of 3 previous months",
        rw: "Duhe amakuru y'umusaruro y'amezi atatu ashize",
      },
      name: "panel_home",
      type: "panel",
      innerIndent: 1,
      elements: [
        {
          title: {
            en: "Month 1",
            rw: "Ukwezi kwa 1",
          },
          name: "agricultural_season_1",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "land_size_season_1",
              type: "text",
              inputType: "number",
              title: {
                en: "Cultivated land in square meters *",
                rw: "Ubutaka buhingwaho muri metero kare *",
              },
              validators: [expressions.land_size_square_meters(), regexValidators.max_three_decimal_places()],
            },
            {
              name: "supply_volume_kg_season_1",
              type: "text",
              inputType: "number",
              isRequired: required,
              title: {
                en: "Production supplied to the exporter in Kgs *",
                rw: "Ingano yumusaruro wagemuwe kuruganda muri Kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_season_1",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko bw'igihingwa wahisemo",
              },
            },
            {
              name: "price_season_1",
              isRequired: required,
              type: "text",
              inputType: "number",
              title: {
                en: "Price paid by the exporter per 1 Kg *",
                rw: "Igiciro wishyuwe nuruganda ku kilo kimwe *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_season_1",
              type: "expression",
              title: {
                en: "Total amount received form exporter",
                rw: "Amafaranga yose wishyuwe n’uruganda",
              },
              expression: "{supply_volume_kg_season_1} * {price_season_1}",
              validators: [regexValidators.max_two_decimal_places()]
            },
          ],
        },
        {
          title: {
            en: "Month 2",
            rw: "Ukwezi kwa 2",
          },
          name: "agricultural_season_2",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "land_size_season_2",
              isRequired: required,
              type: "text",
              inputType: "number",
              title: {
                en: "Cultivated land in square meters *",
                rw: "Ubutaka buhingwaho muri metero kare *",
              },
              validators: [expressions.land_size_square_meters(), regexValidators.max_three_decimal_places()],
            },
            {
              name: "supply_volume_kg_season_2",
              isRequired: required,
              type: "text",
              title: {
                en: "Production supplied to the exporter in Kgs *",
                rw: "Ingano yumusaruro wagemuwe kuruganda muri Kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_season_2",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko bw'igihingwa wahisemo",
              },
            },
            {
              name: "price_season_2",
              type: "text",
              isRequired: required,
              title: {
                en: "Price paid by the exporter per 1 Kg *",
                rw: "Igiciro wishyuwe nuruganda ku kilo kimwe *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_season_2",
              type: "expression",
              title: {
                en: "Total amount received form exporter",
                rw: "Amafaranga yose wishyuwe n’uruganda",
              },
              expression: "{supply_volume_kg_season_2} * {price_season_2}",
              validators: [regexValidators.max_two_decimal_places()]
            },
          ],
        },
        {
          title: {
            en: "Month 3",
            rw: "Ukwezi kwa 3",
          },
          name: "agricultural_season_3",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "land_size_season_3",
              isRequired: required,
              type: "text",
              inputType: "number",
              title: {
                en: "Cultivated land in square meters *",
                rw: "Ubutaka buhingwaho muri metero kare *",
              },
              validators: [expressions.land_size_square_meters(), regexValidators.max_three_decimal_places()],
            },
            {
              name: "supply_volume_kg_season_3",
              isRequired: required,
              type: "text",
              title: {
                en: "Production supplied to the exporter in Kgs *",
                rw: "Ingano yumusaruro wagemuwe kuruganda muri Kilogarama *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_season_3",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko bw'igihingwa wahisemo",
              },
            },
            {
              name: "price_season_3",
              type: "text",
              isRequired: required,
              title: {
                en: "Price paid by the exporter per 1 Kg *",
                rw: "Igiciro wishyuwe nuruganda ku kilo kimwe *",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_season_3",
              type: "expression",
              title: {
                en: "Total amount received form exporter",
                rw: "Amafaranga yose wishyuwe n’uruganda",
              },
              expression: "{supply_volume_kg_season_3} * {price_season_3}",
              validators: [regexValidators.max_two_decimal_places()]
            },
          ],
        },
      ],
    },
    {
      name: "plot_ownership_season_1",
      type: "radiogroup",
      isRequired: required,
      title: {
        en: "Do you own a land ?*",
        rw: "Ufite ubutaka uhingaho ?*",
      },
      choices: [
        {
          value: true,
          text: {
            en: "Yes",
            rw: "Yego",
          },
        },
        {
          value: false,
          text: {
            en: "No",
            rw: "Oya",
          },
        },
      ],
    },
  ],
}

const extra_questions = {
  name: "practice",
  title: {
    en: "Farming Practice Information",
    rw: "Amakuru ajyanye n'imihingire",
  },
  elements: [
    {
      title: {
        en: "On what are you going to spend the loan? *",
        rw: "Inguzanyo uzayikoresha iki? *",
      },
      name: "custom_jsonfield_1",
      type: "checkbox",
      isRequired: required,
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      storeOthersAsComment: false,
      choices: [
        {
          value: "Equipment",
          text: {
            en: "Equipment",
            rw: "Ibikoresho",
          },
        },
        {
          value: "Fertilizer",
          text: {
            en: "Fertilizer",
            rw: "Ifumbire",
          },
        },
        {
          value: "Labor",
          text: {
            en: "Labor",
            rw: "Abakozi",
          },
        },
        {
          value: "Land lending",
          text: {
            en: "Land lending",
            rw: "Gukodesha ubutaka",
          },
        },
        {
          value: "Seeds",
          text: {
            en: "Seeds",
            rw: "Kugura Imbuto",
          },
        },
        {
          value: "Transport",
          text: {
            en: "Transport",
            rw: "Ubwikorezi",
          },
        },
        {
          value: "Pesticides",
          text: {
            en: "Pesticides",
            rw: "Imiti",
          },
        },
      ],
    },
    {
      title: {
        en: "How do you plan to use your profit? *",
        rw: "Niki uzakoresha inyungu yawe? *",
      },
      name: "custom_jsonfield_2",
      type: "checkbox",
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      storeOthersAsComment: false,
      isRequired: required,
      choices: [
        {
          value: "Agriculture investments",
          text: {
            en: "Agriculture investments",
            rw: "Nzongera igishoro mubuhinzi",
          },
        },
        {
          value: "Costs of living",
          text: {
            en: "Costs of living",
            rw: "Kuvugurura inzu",
          },
        },
        {
          value: "Education",
          text: {
            en: "Education",
            rw: "Uburezi",
          },
        },
        {
          value: "Health care",
          text: {
            en: "Health care",
            rw: "Ubwishingizi mu kwivuza",
          },
        },
      ],
    },
    {
      title: {
        en: "What other crops are you cultivating? *",
        rw: "Nibihe  bindi bihingwa uhinga? *",
      },
      name: "custom_jsonfield_3",
      type: "checkbox",
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      hasNone: true,
      noneText: { en: "None", rw: "Ntanakimwe" },
      storeOthersAsComment: false,
      isRequired: required,
      choices: [
        {
          value: "Beans",
          text: {
            en: "Beans",
            rw: "Ibishyimbo",
          },
        },
        {
          value: "Horticulture",
          text: {
            en: "Horticulture",
            rw: "Imboga n'imbuto",
          },
        },
        {
          value: "Maize",
          text: {
            en: "Maize",
            rw: "Ibigori",
          },
        },
        {
          value: "Potato",
          text: {
            en: "Potato",
            rw: "Ibirayi",
          },
        },
        {
          value: "Pyrethrum",
          text: {
            en: "Pyrethrum",
            rw: "Ibireti",
          },
        },
        {
          value: "Chili",
          text: {
            en: "Chili",
            rw: "Urusenda",
          },
        },
        {
          value: "Tea",
          text: {
            en: "Tea",
            rw: "Icyayi",
          },
        },
        {
          value: "Orange Sweet Potato",
          text: {
            en: "Orange Sweet Potato",
            rw: "Ibijumba",
          },
        },
        {
          value: "Livestock",
          text: {
            en: "Livestock",
            rw: "Ubworozi bw'amatungo magufi",
          },
        },
        {
          value: "Poultry",
          text: {
            en: "Poultry",
            rw: "Ubworozi bw'inkoko",
          },
        },
        {
          value: "Onion",
          text: {
            en: "Onion",
            rw: "Ibitunguru",
          },
        },
      ],
    },
    {
      title: {
        en: "Which of the following tools or equipment do you have access to? *",
        rw: "Muri ibi bikoresho nibihe mukoresha? *",
      },
      name: "custom_jsonfield_4",
      type: "checkbox",
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      hasNone: true,
      noneText: { en: "None", rw: "Ntanakimwe" },
      storeOthersAsComment: false,
      isRequired: required,
      choices: [
        {
          value: "Bike",
          text: {
            en: "Bike",
            rw: "Igare",
          },
        },
        {
          value: "Car",
          text: {
            en: "Car",
            rw: "Imodoka",
          },
        },
        {
          value: "Chemical spray",
          text: {
            en: "Chemical spray",
            rw: "Imashini itera umuti",
          },
        },
        {
          value: "Irrigation system",
          text: {
            en: "Irrigation system",
            rw: "Imashini yuhira",
          },
        },
        {
          value: "Motorbike",
          text: {
            en: "Motorbike",
            rw: "Igare",
          },
        },
        {
          value: "Shovel",
          text: {
            en: "Shovel",
            rw: "Amasuka",
          },
        },     
      ],
    },
    {
      title: {
        en: "Do you have access to sustainable technology? *",
        rw: "Ufite ikoranabuhanga rirambye? *",
      },
      name: "custom_jsonfield_5",
      type: "checkbox",
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      hasNone: true,
      noneText: { en: "None", rw: "Ntanakimwe" },
      storeOthersAsComment: false,
      isRequired: required,
      choices: [
        {
          value: "Clean cooking",
          text: {
            en: "Clean cooking",
            rw: "Ibicanwa bitangiza ikirere",
          },
        },
        {
          value: "Solar energy",
          text: {
            en: "Solar energy",
            rw: "Imirasire y'izuba",
          },
        },
        {
          value: "Electricity",
          text: {
            en: "Electricity",
            rw: "Amashanyarazi",
          },
        },
        {
          value: "Rondereza",
          text: {
            en: "Rondereza",
            rw: "Rondereza",
          },
        },
      ],
    },
    {
      title: {
        en: "Which organic methods do you apply in your farming? *",
        rw: "Ni ubuhe buryo mvaruganda ukoresha mu buhinzi bwawe? *",
      },
      name: "custom_jsonfield_6",
      type: "checkbox",
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      hasNone: true,
      noneText: { en: "None", rw: "Ntanakimwe" },
      storeOthersAsComment: false,
      isRequired: required,
      choices: [
        {
          value: "Organic fertilizer",
          text: {
            en: "Organic fertilizer",
            rw: "Ifumbire mvaruganda",
          },
        },
        {
          value: "Organic seeds",
          text: {
            en: "Organic seeds",
            rw: "Ingemwe mvaruganda",
          },
        },
        {
          value: "Organic Pesticides",
          text: {
            en: "Organic Pesticides",
            rw: "Imiti mvaruganda",
          },
        },
      ],
    },
    {
      title: {
        en: "Are you doing any other activities to generate income, besides farming? *",
        rw: "Hari ibindi bikorwa bitanga inyungu mukora, uretse ubuhinzi? *",
      },
        name: "custom_bool_6",
        type: "radiogroup",
        isRequired: required,
        choices: [
          {
            value: true,
            text: { en: "Yes", rw: "Yego" },
          },
          {
            value: false,
            text: { en: "No", rw: "Oya" },
          },
      ],
    },
    {
      title: {
        en: "If yes, what of these activities? *",
        rw: "Niba ari yego, nibihe? *",
      },
      name: "custom_jsonfield_7",
      type: "checkbox",
      visibleIf: "{custom_bool_6} == true",
      isRequired: required,
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      storeOthersAsComment: false,
      choices: [
        {
          value: "Tranportation",
          text: {
            en: "Tranportation",
            rw: "Ubwikorezi",
          },
        },
        {
          value: "Trade / Market Sales",
          text: {
            en: "Trade / Market Sales",
            rw: "Ubucuruzi / Kugurisha ku isoko",
          },
        },
        {
          value: "Processing",
          text: {
            en: "Processing",
            rw: "Gutunganya",
          },
        },
        {
          value: "Agro-dealer",
          text: {
            en: "Agro-dealer",
            rw: "Abaranguza iby'ubuhinzi",
          },
        },
        {
          value: "Other (non-agricultural)",
          text: {
            en: "Other (non-agricultural)",
            rw: "Ibindi (bitari ubuhinzi)",
          },
        },
      ],
    },
    {
      title: {
        en: "Are you a member of a saving group? *",
        rw: "Mubarizwa mu itsinda ry'ubwizigame? *",
      },
        name: "custom_bool_7",
        type: "radiogroup",
        isRequired: required,
        choices: [
          {
            value: true,
            text: { en: "Yes", rw: "Yego" },
          },
          {
            value: false,
            text: { en: "No", rw: "Oya" },
          },
      ],
    },
    {
      title: {
        en: "Is that saving group within your cooperative? *",
        rw: "Iryo tsinda ribarizwa muri cooperative? *",
      },
      name: "custom_bool_8",
      type: "radiogroup",
      visibleIf: "{custom_bool_7} == true",
      isRequired: required,
      storeOthersAsComment: false,
        choices: [
          {
            value: true,
            text: { en: "Yes", rw: "Yego" },
          },
          {
            value: false,
            text: { en: "No", rw: "Oya" },
          },
      ],
    },
    {
      title: {
        en: "How many people did you employ the last 6 months? *",
        rw: "Ni abantu bangahe wahaye akazi mu mezi 6 ashize? *",
      },
      name: "custom_integer_2",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
    {
      title: {
        en: "How many of these are permanent employees? (Permanent employ more than 6 months) *",
        rw: "Muri aba ni bangahe bahoraho? (Abahoraho bamaze amezi arenga 6) *",
      },
      name: "custom_integer_3",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
    {
      title: {
        en: "How many of these are temporary/seasonal employees? (temporary employ less than  6 months) *",
        rw: "Muri aba ni bangahe badahoraho/bakora ku gihembwe? (Abadahoraho bamaze amezi munsi ya 6) *",
      },
      name: "custom_integer_4",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
    {
      title: {
        en: "How many of these are women? *",
        rw: "Muribo harimo abagore bangahe? *",
      },
      name: "custom_integer_5",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
    {
      title: {
        en: "How many of these are youth? Below 35 years old. *",
        rw: "Muribo harimo urubyiruko rungahe? Munsi y'imyaka 35. *",
      },
      name: "custom_integer_6",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
    {
      title: {
        en: "How many of these have a disability? *",
        rw: "Muribo harimo ababana n'ubumuga bangahe? *",
      },
      name: "custom_integer_7",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
  ],
}

const financial_information = (clientUrlForCatalog) => [{
  name: "financial",
  title: {
    en: "Financial Information",
    rw: "Amakuru ku nguzanyo",
  },
  elements: [
    {
      title: {
        en: "How much do you want to borrow ?*",
        rw: "Urashaka kuguza angahe ?*",
      },
      name: "amount",
      type: "nouislider",
      visibleIf: "{loan_purpose} == 'onion'",
      step: 1000,
      rangeMin: 100000,
      rangeMax: 500000,
      isRequired: required,
      validators: [
        expressions.amount_in_range(100000, 500000),
      ],
    },
    {
      title: {
        en: "How much do you want to borrow ?*",
        rw: "Urashaka kuguza angahe ?*",
      },
      name: "amount",
      type: "nouislider",
      visibleIf: "{loan_purpose} == 'orange_sweet_potato' || {loan_purpose} == 'fish' || {loan_purpose} == 'tomato'",
      step: 1000,
      rangeMin: 100000,
      rangeMax: 500000,
      isRequired: required,
      validators: [
        expressions.amount_in_range(100000, 500000),
      ],
    },
    {
      title: {
        en: "How much do you want to borrow ?*",
        rw: "Urashaka kuguza angahe ?*",
      },
      name: "amount",
      type: "nouislider",
      visibleIf: "{loan_purpose} == 'potatoes' || {loan_purpose} == 'chili' || {loan_purpose} == 'avocado' || {loan_purpose} == 'passion_fruit' || {loan_purpose} == 'maize' || {loan_purpose} == 'coffee'",
      step: 1000,
      rangeMin: 100000,
      rangeMax: 2000000,
      isRequired: required,
      validators: [expressions.amount_in_range(100000, 2000000)],
    },
    {
      title: {
        en: "How much do you want to borrow ?*",
        rw: "Urashaka kuguza angahe ?*",
      },
      name: "amount",
      type: "nouislider",
      visibleIf: "{loan_purpose} != 'orange_sweet_potato' && {loan_purpose} != 'coffee' && {loan_purpose} != 'potatoes' && {loan_purpose} != 'chili' && {loan_purpose} != 'fish' && {loan_purpose} != 'avocado' && {loan_purpose} != 'passion_fruit' && {loan_purpose} != 'tomato' && {loan_purpose} != 'onion' && {loan_purpose} != 'maize'",
      step: 1000,
      rangeMin: 100000,
      rangeMax: 1000000,
      isRequired: required,
      validators: [
        expressions.amount_in_range(100000, 1000000),
      ],
    },
    {
      type: "html",
      name: "amount_note",
      html: {
        en: "We inform you that a repayment period of {repayment_period} months has been approved for the requested crop loan.",
        rw: "Turakumenyesha igihe cyo kwishuyura cy'amazi {repayment_period} cyemejwe ku nguzanyo y'igihingwa",
      },
    },
    // {
    //   title: {
    //     en: "How long do you want to borrow this amount?",
    //     rw: "Urashaka gusaba ingunzayo y’igihe kingana gute?",
    //   },
    //   name: "repayment_period",
    //   type: "dropdown",
    //   visibleIf: "{amount} > 500000",
    //   choices: [
    //     {
    //       value: 6,
    //       text: { en: "6 months ( 1 repayment)", rw: "Amezi 6 ( Kwishyura micyiro 1)" },
    //     },
    //     {
    //       value: 12,
    //       text: { en: "12 months (2 repayments)", rw: "Amezi 12 ( Kwishyura mubyiciro 2)" },
    //     },
    //   ],
    // },
    // {
    //   type: "html",
    //   visibleIf: "{repayment_period} == 12",
    //   html: {
    //     en: "Be aware that you need to repay the loan in 2 times, half after 6 months and the other half after 12 months.",
    //     rw: "Niyemeje kwishyura  inguzanyo mubyiciro bibiri (2) icyambere nyuma y’amezi atandatu(6) ikindi cyiciro nyuma y’amezi 12",
    //   },
    // },
    {
      name: "phone_validation",
      type: "html",
      html: {
        en: `<h4><strong>Please make sure that you provide the correct phone number registered to your mobile wallet. MoneyPhone
              Africa is not responsible for disbursements made to phone numbers that do not belong to the intended farmer.</strong></h4>`,
        rw: `<h4><strong>Nyamuneka menya neza ko utanze nimero ya telefone yanditswe kuri konti yawe ya mobile money. MoneyPhone
              Africa ntizirengera ingaruka zizaba mugihe hatanzwe nimero z'itumanaho zitari iz'umuhinzi wagenewe amafaranga.</strong></h4>`,
      }
    },
    {
      name: "phone_number",
      type: "phone",
      isRequired: required,
      validators: [expressions.phone_en("phone_number"), expressions.phone_length("phone_number")],
      title: {
        en: "Mobile No. 1 *",
        rw: "Numero ya telefone *",
      },
    },
    {
      title: {
        en: "Do you have a mobile wallet ?*",
        rw: "Ufite konti y'amafaranga kuri telephone ?*",
      },
      name: "custom_text_5",
      type: "dropdown",
      isRequired: required,
      choices: [
        {
          value: "yes",
          text: { en: "Yes", rw: "Yego" },
        },
        {
          value: "no",
          text: { en: "No", rw: "Oya" },
        },
      ],
    },
    {
      title: {
        en: "Select your mobile wallet",
        rw: "Hitamo konti y'amafaranga ya telephone ukoresha",
      },
      name: 'custom_text_6',
      type: 'dropdown',
      visibleIf: "{custom_text_5} == 'yes'",
      choices: [
        { value: "MTN", text: { en: "MTN", "rw": "MTN" } },
        { value: "Airtel", text: { en: "Airtel", "rw": "Airtel" } },
      ],
    },
    {
      title: {
        en: "Do you have a bank account?",
        rw: "Ufite konti muri Banki",
      },
      name: "custom_text_7",
      type: "dropdown",
      choices: [
        {
          value: "yes",
          text: { en: "Yes", rw: "Yego" },
        },
        {
          value: "no",
          text: { en: "No", rw: "Oya" },
        },
      ],
    },
    {
      type: "panel",
      visibleIf: '{custom_text_7} == "yes"',
      innerIndent: 1,
      name: "bank_panel",
      elements: [
        {
          title: {
            en: "Name of the Bank *",
            rw: "Izina rya konti ya Banki *",
          },
          name: "custom_text_8",
          type: "dropdown",
          isRequired: required,
          hasOther: true,
          otherText: { en: "Other", rw: "Ibindi" },
          storeOthersAsComment: false,
          choicesByUrl: {
            url: `${clientUrlForCatalog}/api/tenant-data/bank_names/`,
            path: "results",
            titleName: "value",
            valueName: "value",
            attachOriginalItems: true,
          }
        },
        {
          title: {
            en: "Bank account number *",
            rw: "Nimero ya konti ya Banki *",
          },
          name: "custom_text_9",
          type: "text",
          isRequired: required,
        },
      ],
    },
    {
      title: {
        en: 'Where do you prefer to receive the money ?*',
        rw: 'Urashaka ko amafaranga yawe azanyuzwa hehe ?*',
      },
      name: 'preferred_payment_method',
      type: 'dropdown',
      isRequired: required,
      choices: [
        {
          value: 'mobile_wallet',
          text: { en: 'Mobile wallet', rw: 'Kuri konti ya telephone' },
        },
        {
          value: 'bank_account',
          text: { en: 'Bank account', rw: 'Konti ya Banki' },
        },
      ],
      validators: [
        {
          type: "expression",
          expression: "templateConditional({custom_text_6} notempty, {custom_text_9} notempty, {preferred_payment_method}, 'mobile_wallet')",
          text: {
            en: "Please confirm the details for selection",
            rw: "Emeza amahitamo yawe",
          }
        },
      ],
    },
    {
      html: {
        en: "We will transfer the money to the wallet connected to the phone number used in this application",
        "rw": "Tuzohereza amafaranga kuri nimero watanze usaba iyi inguzanyo ndetse ihuye n’umwirondoro wawe",
      },
      visibleIf: "{preferred_payment_method} == 'mobile_wallet'",
      type: "html",
    },
    {
      html: {
        en: "We will transfer the money to the bank account you mentioned above connected to the identification used during the application",
        "rw": "Tuzohereza amafaranga kuri konti watanze haruguru kandi ihuye numwirondoro wawe bwite",
      },
      visibleIf: "{preferred_payment_method} == 'bank_account'",
      type: "html",
    },
    {
      name: "file_2",
      type: "file_uploader",
      accept: "image/*,application/pdf",
      title: {
        en: "Upload your Bank Statement or Mobile Money statement",
        rw: "Shyiraho urupapuro rwerekana uko ubitsa cg ubikuza kuri Banki cg Telephone",
      },
    },
    {
      title: {
        en: "Do you own a smartphone ?*",
        rw: "Ufite telefoni igendanwa ya smartphone ?*",
      },
      name: "custom_bool_2",
      type: "radiogroup",
      isRequired: required,
      choices: [
        {
          value: true,
          text: { en: "Yes", rw: "Yego" },
        },
        {
          value: false,
          text: { en: "No", rw: "Oya" },
        },
      ]
    },
  ],
}]

const guarantor_information = (clientUrlForCatalog) => [
  {
    title: {
      en: "Information related to your Guarantor",
      rw: "Amakuru ajyanye n'umwishingizi wawe",
    },
    name: "home",
    elements: [
      // Cooperatives
      {
        name: "cooperative_name",
        type: "dropdown",
        isRequired: required,
        title: {
          en: "Name of the Cooperative *",
          rw: "Izina rya Cooperative *",
        },
        choicesByUrl: {
          url: `${clientUrlForCatalog}/api/cooperatives/?product={loan_purpose}`,
          path: "results",
          titleName: "name",
          valueName: "name",
          attachOriginalItems: true,
        },
      },
      {
        title: {
          en: "Do you have an off-taker for your produce ?*",
          rw: "Mufite umuguzi w'umusaruro wanyu ?*",
        },
        name: "custom_text_11",
        type: "dropdown",
        visibleIf: "{loan_purpose} == 'orange_sweet_potato'",
        isRequired: required,
        choices: [
          {
            value: "yes",
            text: { en: "Yes", rw: "Yego" },
          },
          {
            value: "no",
            text: { en: "No", rw: "Oya" },
          },
        ],
      },
      {
        title: { en: "What is the name of your off-taker ?*", rw: "mwatubwira amazina y'umuguzi wanyu ?*" },
        name: "custom_text_12",
        type: "text",
        isRequired: required,
        visibleIf: "{custom_text_11} == 'yes'",
      },
    ],
  },
];


const cooking_stove = {
  title: {
    en: "Information related to the cooking stove",
    rw: "Amakuru",
  },
  name: "home",
  elements: [
    { type: "text", name: "OffersCookingStove", defaultValueExpression: "{cooperative.offers_cooking_stove}", visible: false},
    {
      title: {
        en: "Would you like to buy a cooking stove for RWF { cooking_stove_amount } included in your loan request ?*",
        rw: "Urashaka gushyiramo amashyiga yo guteka mubyifuzo byawe byinguzanyo ?*",
      },
      name: "custom_bool_3",
      type: "radiogroup",
      visibleIf: "{OffersCookingStove} = true",
      isRequired: true,
      default: false,
      choices: [
        {
          value: true,
          text: {
            en: "Yes, I want to buy a cooking stove ({cooking_stove_amount} RWF will be deducted from my loan amount).",
            rw: "Yego, ndifuza kugura imbabura ya kijyambere ({cooking_stove_amount} rwf azakurwa ku nguzanyo nasabye).",
          },
        },
        {
          value: false,
          text: {
            en: "No, I do not want to buy a cooking stove.",
            rw: "Oya, Ntabwo nifuza kugura imbabura ya kijyambere.",
          },
        },
      ],
    },
  ],
};

const extra_questions_fish = {
  name: "practice",
  title: {
    en: "Farming Practice Information",
    rw: "Amakuru ajyanye n'imihingire",
  },
  elements: [
    {
      title: {
        en: "On what are you going to spend the loan? *",
        rw: "Inguzanyo uzayikoresha iki? *",
      },
      name: "custom_jsonfield_1",
      type: "checkbox",
      isRequired: required,
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      storeOthersAsComment: false,
      choices: [
        {
          value: "Fish nets",
          text: {
            en: "Fish nets",
            rw: "Inshundura zo kuroba",
          },
        },
        {
          value: "Boats",
          text: {
            en: "Boats",
            rw: "ubwato",
          },
        },
        {
          value: "Fishing lights",
          text: {
            en: "Fishing lights",
            rw: "amatara yo kuroba",
          },
        },
        {
          value: "Labor",
          text: {
            en: "Labor",
            rw: "Abakozi",
          },
        },
        {
          value: "Hooks",
          text: {
            en: "Hooks",
            rw: "Ifirime",
          },
        },
        {
          value: "Fish containers",
          text: {
            en: "Fish containers",
            rw: "Ububiko bw'amafi",
          },
        },
        {
          value: "Life jackets",
          text: {
            en: "Life jackets",
            rw: "Amakoti y'ubwirinzi",
          },
        },
      ],
    },
    {
      title: {
        en: "How do you plan to use your profit? *",
        rw: "Niki uzakoresha inyungu yawe? *",
      },
      name: "custom_jsonfield_2",
      type: "checkbox",
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      storeOthersAsComment: false,
      isRequired: required,
      choices: [
        {
          value: "Investments",
          text: {
            en: "Investments",
            rw: "Ishoramari",
          },
        },
        {
          value: "Cost of living",
          text: {
            en: "Cost of living",
            rw: "Imibereho",
          },
        },
        {
          value: "Education",
          text: {
            en: "Education",
            rw: "Uburezi",
          },
        },
        {
          value: "Health care",
          text: {
            en: "Health care",
            rw: "Kwivuza",
          },
        },
      ],
    },
    {
      title: {
        en: "What other types of fish do you catch?",
        rw: "N'ubuhe bwoko bundi bw'amafi muroba?",
      },
      name: "custom_jsonfield_3",
      type: "checkbox",
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      hasNone: true,
      noneText: { en: "None", rw: "Ntanakimwe" },
      storeOthersAsComment: false,
      isRequired: required,
      choices: [
        {
          value: "Tilapia",
          text: {
            en: "Tilapia",
            rw: "Tilapia",
          },
        },
        {
          value: "Inkuba imamba",
          text: {
            en: "Inkuba imamba",
            rw: "Inkuba imamba",
          },
        },
        {
          value: "Indungu",
          text: {
            en: "Indungu",
            rw: "Indungu",
          },
        },
      ],
    },
    {
      title: {
        en: "Which of the following tools or equipment do you have access to? *",
        rw: "Muri ibi bikoresho nibihe mukoresha? *",
      },
      name: "custom_jsonfield_4",
      type: "checkbox",
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      hasNone: true,
      noneText: { en: "None", rw: "Ntanakimwe" },
      storeOthersAsComment: false,
      isRequired: required,
      choices: [
        {
          value: "Fish traps",
          text: {
            en: "Fish traps",
            rw: "Imitego y'amafi",
          },
        },
        {
          value: "Engine",
          text: {
            en: "Engine",
            rw: "Essence",
          },
        },
        {
          value: "Boat",
          text: {
            en: "Boat",
            rw: "Ubwato",
          },
        },
        {
          value: "Fishing nets",
          text: {
            en: "Fishing nets",
            rw: "Inshundura z'amafi",
          },
        },
        {
          value: "Fishing hooks and lines",
          text: {
            en: "Fishing hooks and lines",
            rw: "Ifirime n'ibyuma byo gutega",
          },
        },     
      ],
    },
    {
      title: {
        en: "Which organic methods do you apply in your fishing? *",
        rw: "N'ubuhe bwoko bw'ifumbire mwifashisha mu burobyi? *",
      },
      name: "custom_jsonfield_6",
      type: "checkbox",
      hasNone: true,
      noneText: { en: "None", rw: "Ntanakimwe" },
      storeOthersAsComment: false,
      isRequired: required,
      choices: [
        {
          value: "Use of selective fishing nets (avoid small/young fish)",
          text: {
            en: "Use of selective fishing nets (avoid small/young fish)",
            rw: "Gukoresha inshundura kabuhariwe (zidafata amafi mato)",
          },
        },
        {
          value: "Fishing only during allowed seasons",
          text: {
            en: "Fishing only during allowed seasons",
            rw: "Kuroba mu bihe byabugenewe",
          },
        },
        {
          value: "Avoiding chemicals or explosives",
          text: {
            en: "Avoiding chemicals or explosives",
            rw: "Kwirinda ibiturinda cyangwa ibyangiza",
          },
        },
        {
          value: "Using traditional/manual fishing methods",
          text: {
            en: "Using traditional/manual fishing methods",
            rw: "Gukoresha uburyo bwo kuroba bwa gakondo",
          },
        },
      ],
    },
    {
      title: {
        en: "Are you doing any other activities to generate income, besides fishing? *",
        rw: "Hari ibindi bikorwa byunguka mufite, uretse uburobyi? *",
      },
        name: "custom_bool_6",
        type: "radiogroup",
        isRequired: required,
        choices: [
          {
            value: true,
            text: { en: "Yes", rw: "Yego" },
          },
          {
            value: false,
            text: { en: "No", rw: "Oya" },
          },
      ],
    },
    {
      title: {
        en: "If yes, what of these activities? *",
        rw: "Niba ari yego, nibihe? *",
      },
      name: "custom_jsonfield_7",
      type: "checkbox",
      visibleIf: "{custom_bool_6} == true",
      isRequired: required,
      hasOther: true,
      otherText: { en: "Other", rw: "Ibindi" },
      storeOthersAsComment: false,
      choices: [
        {
          value: "Small farming / Agriculture",
          text: {
            en: "Small farming / Agriculture",
            rw: "Ubuhinzi bworoheje",
          },
        },
        {
          value: "Livestock rearing",
          text: {
            en: "Livestock rearing",
            rw: "Kwita ku matongo",
          },
        },
        {
          value: "Small business or trading",
          text: {
            en: "Small business or trading",
            rw: "Ubucuruzi bworoheje",
          },
        },
        {
          value: "Other",
          text: {
            en: "Other",
            rw: "Ibindi",
          },
        },
      ],
    },
    {
      title: {
        en: "Are you a member of a saving group? *",
        rw: "Mubarizwa mu itsinda ry'ubwizigame? *",
      },
        name: "custom_bool_7",
        type: "radiogroup",
        isRequired: required,
        choices: [
          {
            value: true,
            text: { en: "Yes", rw: "Yego" },
          },
          {
            value: false,
            text: { en: "No", rw: "Oya" },
          },
      ],
    },
    {
      title: {
        en: "Is that saving group within your cooperative? *",
        rw: "Iryo tsinda ribarizwa muri cooperative? *",
      },
      name: "custom_bool_8",
      type: "radiogroup",
      visibleIf: "{custom_bool_7} == true",
      isRequired: required,
      storeOthersAsComment: false,
        choices: [
          {
            value: true,
            text: { en: "Yes", rw: "Yego" },
          },
          {
            value: false,
            text: { en: "No", rw: "Oya" },
          },
      ],
    },
    {
      title: {
        en: "How many people did you employ the last 6 months? *",
        rw: "Ni abantu bangahe wahaye akazi mu mezi 6 ashize? *",
      },
      name: "custom_integer_2",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
    {
      title: {
        en: "How many of these are permanent employees? (Permanent employ more than 6 months) *",
        rw: "Muri aba ni bangahe bahoraho? (Abahoraho bamaze amezi arenga 6) *",
      },
      name: "custom_integer_3",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
    {
      title: {
        en: "How many of these are temporary/seasonal employees? (temporary employ less than  6 months) *",
        rw: "Muri aba ni bangahe badahoraho/bakora ku gihembwe? (Abadahoraho bamaze amezi munsi ya 6) *",
      },
      name: "custom_integer_4",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
    {
      title: {
        en: "How many of these are women? *",
        rw: "Muribo harimo abagore bangahe? *",
      },
      name: "custom_integer_5",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
    {
      title: {
        en: "How many of these are youth? Below 35 years old. *",
        rw: "Muribo harimo urubyiruko rungahe? Munsi y'imyaka 35. *",
      },
      name: "custom_integer_6",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
    {
      title: {
        en: "How many of these have a disability? *",
        rw: "Muribo harimo ababana n'ubumuga bangahe? *",
      },
      name: "custom_integer_7",
      type: "text",
      inputType: "number",
      isRequired: required,
      validators: [
        {
          type: "numeric",
          minValue: 0,
          text: {
            en: "Please make sure the number is 0 or more",
            rw: "Nyamuneka menya neza ko umubare ari 0 cyangwa urenzeho",
          },
        },
      ],
    },
  ],
}

const production_information_fish = {
  name: "production",
  title: {
    en: "Production Information",
    rw: "Amakuru y'umusaruro",
  },
  description: {
    en: "The production information provided will be verified and confirmed by the cooperative.",
    rw: "Amakuru y'umusaruro azasuzumwa kandi yemezwe na koperative",
  },
  elements: [
    {
      title: {
        en: "Provide us with production information of 2 two previous months production",
        rw: "Duhe amakuru y'umusaruro w'amezi abiri ashize",
      },
      name: "panel_home",
      type: "panel",
      innerIndent: 1,
      elements: [
        {
          title: {
            en: "Month 1",
            rw: "Ukwezi kwa 1",
          },
          name: "Fisheries_season_1",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "supply_volume_kg_season_1",
              type: "text",
              inputType: "number",
              isRequired: required,
              title: {
                en: 'Production in KGs',
                rw: "Umusaruro mu biro",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_season_1",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko bw'igihingwa wahisemo",
              },
            },
            {
              name: "price_season_1",
              isRequired: required,
              type: "text",
              inputType: "number",
              title: {
                en: 'Price in RWF',
                rw: 'Igiciro muri RWF',
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_season_1",
              type: "text",
              inputType: "number",
              isRequired: required,
              title: {
                en: 'Sales in RWF',
                rw: 'Ibyagurishijwe mu RWF',
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
          ],
        },
        {
          title: {
            en: "Month 2",
            rw: "Ukwezi kwa 2",
          },
          name: "Fisheries_season_2",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "supply_volume_kg_season_2",
              isRequired: required,
              type: "text",
              title: {
                en: 'Production in KGs',
                rw: "Umusaruro mu biro",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_season_2",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko bw'igihingwa wahisemo",
              },
            },
            {
              name: "price_season_2",
              type: "text",
              isRequired: required,
              title: {
                en: 'Price in RWF ',
                rw: 'Igiciro muri RWF',
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_season_2",
              type: "text",
              isRequired: required,
              title: {
                en: 'Sales in Rwf',
                rw: 'Ibyagurishijwe mu RWF',
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
          ],
        },
        {
          title: {
            en: "Information on current month",
            rw: "Amakuru y'ukwezi utujuje",
          },
          name: "Fisheries_current_season",
          type: "panel",
          innerIndent: 1,
          elements: [
            {
              name: "supply_volume_kg_current_season",
              type: "text",
              isRequired: required,
              title: {
                en: 'Expected production in KGs',
                rw: "Umusaruro witezwe mu biro (KGs)",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "variety_current_season",
              type: "text",
              title: {
                en: "Variety",
                rw: "Ubwoko uteganya guhinga",
              },
            },
            {
              name: "price_current_season",
              type: "text",
              isRequired: required,
              title: {
                en: 'Expected price in RWF',
                rw: "Igiciro gitezwe muri RWF",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
            {
              name: "sales_current_season",
              type: "text",
              isRequired: required,
              title: {
                en: 'Expected sales in Rwf',
                rw: "Ibyagurishijwe biteganyijwe mu RWF",
              },
              validators: [regexValidators.max_two_decimal_places()],
            },
          ],
        },
      ],
    },
  ],
}

export const intake_rwanda_direct_model_pages_default = (clientUrlForCatalog) => [
  // Page 1: Information related to your Guarantor
  ...guarantor_information(clientUrlForCatalog),
  // Page 2: Applicant Information
  applicant_information,
  // Page 3: Identification Information
  identification_information,
  // Page 4: Residence & Home Information
  ...residence_and_home_information(clientUrlForCatalog),
  // Page 5: Production Information
  production_information_default,
  // Page 6: Extra questions
  extra_questions,
  // Page 7: Financial Information
  ...financial_information(clientUrlForCatalog),
  // Page 8: Cooking stove 
  cooking_stove,
];

export const intake_rwanda_direct_model_pages_chili = (clientUrlForCatalog) => [
  // Page 1: Information related to your Guarantor
  ...guarantor_information(clientUrlForCatalog),
  // Page 2: Applicant Information
  applicant_information,
  // Page 3: Identification Information
  identification_information,
  // Page 4: Residence & Home Information
  ...residence_and_home_information(clientUrlForCatalog),
  // Page 5: Production Information
  production_information_chili,
  // page 6 Extra questions
  extra_questions,
  // Page 7: Financial Information
  ...financial_information(clientUrlForCatalog),
  // Page 8: Cooking stove
  cooking_stove,
];

export const intake_rwanda_direct_model_pages_tea = (clientUrlForCatalog) => [
  // Page 1: Information related to your Guarantor
  ...guarantor_information(clientUrlForCatalog),
  // Page 2: Applicant Information
  applicant_information,
  // Page 3: Identification Information
  identification_information,
  // Page 4: Residence & Home Information
  ...residence_and_home_information(clientUrlForCatalog),
  // Page 5: Production Information
  production_information_tea,
  // page 6 Extra questions
  extra_questions,
  // Page 7: Financial Information
  ...financial_information(clientUrlForCatalog),
  // Page 8: Cooking stove
  cooking_stove,
];

export const intake_rwanda_direct_model_pages_fish = (clientUrlForCatalog) => [
  // Page 1: Information related to your Guarantor
  ...guarantor_information(clientUrlForCatalog),
  // Page 2: Applicant Information
  applicant_information,
  // Page 3: Identification Information
  identification_information,
  // Page 4: Residence & Home Information
  ...residence_and_home_information(clientUrlForCatalog),
  // Page 5: Production Information
  production_information_fish,
  // Page 6: Extra questions
  extra_questions_fish,
  // Page 7: Financial Information
  ...financial_information(clientUrlForCatalog),
  // Page 8: Cooking stove
  cooking_stove,
];

// Reusable group member intake configuration for irrigation system products
// Requires exactly 5 group members as per business requirements
const irrigation_system_group_intake = (clientUrlForCatalog) => [
    {
        title: {
            en: "Group information",
            rw: "Amakuru y'itsinda",
        },
        elements: [
            {
                type: "html",
                html: {
                    en: "You are applying for a solar irrigation system through your cooperative with a fixed loan amount of {amount} RWF",
                    rw: "Murasaba uburyo bwo kuhira imyaka binyuze muri Koperative yanyu ku nguzanyo y’amafranga kuva kuri FRW {amount}",
                },
            },
            {
               name: "cooperative_name",
               type: "dropdown",
               isRequired: required,
               title: {
                  en: "Name of the Cooperative *",
                  rw: "Izina rya Cooperative *",
                },
                choicesByUrl: {
                  url: `${clientUrlForCatalog}/api/cooperatives/?product={loan_purpose}`,
                  path: "results",
                  titleName: "name",
                  valueName: "name",
                  attachOriginalItems: true,
                },
            },
            {
                name: "custom_jsonfield_8",
                title: {
                    en: "Group members - Add 4 group members",
                    rw: "Abagize itsinda - Ongeraho abagize itsinda 4",
                },
                type: "matrixdynamic",
                isRequired: "{custom_bool_10} == true",
                visibleIf: "{custom_bool_10} == true",
                minRowCount: 4,
                rowCount: 4,
                horizontalScroll: true,
                columnLayout: "vertical",
                addRowLocation: "bottom",
                columnMinWidth: "130px",
                addRowText: {
                    en: "Add",
                    rw: "Ongeraho",
                },
                validators: [
                    {
                        type: "expression",
                        text: {
                            en: "Please make sure to input different phone numbers for all members.",
                            rw: "Emeza ko wanditse nimero z'itelephone zitandukanye ku bagize itsinda bose.",
                        },
                        expression: `differentPhoneNumbers({custom_jsonfield_8}, 'phone') == true`,
                    },
                    {
                        type: "expression",
                        text: {
                          en: "Group member phone numbers cannot be the same as the group leader's phone number.",
                          rw: "Nimero za terefone z'abagize itsinda ntishobora kuba zimwe na zo umuyobozi w'itsinda.",
                        },
                         expression: `samePhoneNumbersMatrix({custom_jsonfield_8}, {phone_number}, 'phone') == true`,
                    },
                ],
                columns: [
                    {
                        title: {
                            en: "Member name",
                            rw: "Izina",
                        },
                        cellType: "text",
                        inputType: "string",
                        name: "first_name",
                        isRequired: required,
                    },
                    {
                        title: {
                            en: "Member Phone number",
                            rw: "Nimero ya terefone",
                        },
                        name: "phone",
                        cellType: "phone",
                        inputType: "string",
                        isRequired: required,
                        validators: [
                            expressions.phone_en("phone"),
                            expressions.phone_length("phone"),
                            expressions.same_phone_number("phone")
                        ],
                    },
                ],
            },
        ],
    },
];

const intake_rwanda_direct_model_pages_irrigation_system = (clientUrlForCatalog) => [
    // Group member intake (5 members required)
    ...irrigation_system_group_intake(clientUrlForCatalog),
    // Page 2: Applicant Information
    applicant_information,
    // Page 3: Identification Information
    identification_information,
    // Page 4: Residence & Home Information
    ...residence_and_home_information(clientUrlForCatalog),
    // Page 5: Production Information
    production_information_default,
    // page 6 Extra questions
    extra_questions,
    // Page 7: Extra questions
    {
        name: "extra",
        title: {
            en: "Extra questions",
            rw: "Ibindi bibazo",
        },
        elements: [
            {
                title: {
                    en: "Do you own a smartphone ?*",
                    rw: "Ufite telefoni igendanwa ya smartphone ?*",
                },
                name: "custom_bool_2",
                type: "radiogroup",
                isRequired: required,
                choices: [
                    {
                        value: true,
                        text: {en: "Yes", rw: "Yego"},
                    },
                    {
                        value: false,
                        text: {en: "No", rw: "Oya"},
                    },
                ]
            },
        ],
    },
]

export const intake_rwanda_direct_model_pages_irrigation_system_ecm = intake_rwanda_direct_model_pages_irrigation_system;

export const intake_rwanda_direct_model_pages_irrigation_system_ignite = intake_rwanda_direct_model_pages_irrigation_system;
